import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ApmSelectJobsFlow } from './ApmSelectJobsFlow';

const ZONE_ID = 'apm-select-jobs-multi';

/**
 * Pallet multi-job selection via apm-select-jobs MFE (grid → prepare → start-jobs).
 */
const MultiJobSelectFlow = ({
  machineRef,
  machineId,
  erpResources,
  onCancel,
  onComplete,
}) => {
  const context = useMemo(() => {
    return {
      machineRef,
      machineId,
      erpResources,
      selectionMode: 'multi',
    };
  }, [machineRef, machineId, erpResources]);

  return (
    <ApmSelectJobsFlow
      zoneId={ZONE_ID}
      context={context}
      onCancel={onCancel}
      onComplete={onComplete}
    />
  );
};

MultiJobSelectFlow.propTypes = {
  machineRef: PropTypes.number,
  machineId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  erpResources: PropTypes.arrayOf(PropTypes.string),
  onCancel: PropTypes.func.isRequired,
  onComplete: PropTypes.func,
};

MultiJobSelectFlow.defaultProps = {
  machineRef: undefined,
  machineId: undefined,
  erpResources: undefined,
  onComplete: undefined,
};

export { MultiJobSelectFlow };
